// CountryTabs.js
import React, { useState } from "react";
import { useParams } from "react-router-dom";
// import CountryDetailFacts from "./CountryDetailFacts";
import { countriesDatabase } from "../data/countriesDatabase";
import School from "../assets/School.svg";
import Health from "../assets/health.svg";
import Rent from "../assets/rent.svg";
import Transport from "../assets/transport.svg";
import Food from "../assets/food.svg";
import Student from "../assets/student.svg";
import Money from "../assets/Money.svg";
import Language from "../assets/Language.svg";
import Gdp from "../assets/Gdp.svg";
import Flag from "../assets/Flag.svg";
import Phone from "../assets/Phone.svg";
import Population from "../assets/Population.svg";
import Uni from "../assets/Uni.svg";
import Check from "../assets/check.svg";

const CountryTabs = ({ countryData }) => {
  const [activeTab, setActiveTab] = useState("overview");
  const { countryCode } = useParams();
  const country = countriesDatabase[countryCode];

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  if (!country) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <h2 className="text-3xl text-red-600">Country Not Found</h2>
      </div>
    );
  }

  return (
    <div className="bg-alice-blue rounded-2xl py-6">
      {/* Tabs */}
      <div className="flex overflow-x-scroll space-x-6 justify-between px-8 pb-6">
        <button
          className={`px-8 py-1 ${
            activeTab === "overview"
              ? "bg-primary text-white rounded-xl"
              : "border border-primary rounded-xl text-primary hover:text-white hover:bg-primary duration-300"
          }`}
          onClick={() => handleTabChange("overview")}
        >
          OVERVIEW
        </button>
        <button
          className={`px-8 py-2 font-medium ${
            activeTab === "schools"
              ? "bg-primary text-white rounded-xl"
              : "border border-primary rounded-xl text-primary hover:text-white hover:bg-primary duration-300"
          }`}
          onClick={() => handleTabChange("schools")}
        >
          SCHOOLS
        </button>
        <button
          className={`px-8 py-2 font-medium ${
            activeTab === "programs"
              ? "bg-primary text-white rounded-xl"
              : "border border-primary rounded-xl text-primary hover:text-white hover:bg-primary duration-300"
          }`}
          onClick={() => handleTabChange("programs")}
        >
          PROGRAMS
        </button>
        <button
          className={`px-8 py-2 font-medium ${
            activeTab === "admissions"
              ? "bg-primary text-white rounded-xl"
              : "border border-primary rounded-xl text-primary hover:text-white hover:bg-primary duration-300"
          }`}
          onClick={() => handleTabChange("admissions")}
        >
          ADMISSIONS
        </button>
        <button
          className={`px-8 py-2 font-medium ${
            activeTab === "tuition"
              ? "bg-primary text-white rounded-xl"
              : "border border-primary rounded-xl text-primary hover:text-white hover:bg-primary duration-300"
          }`}
          onClick={() => handleTabChange("tuition")}
        >
          COST OF LIVING & TUITION
        </button>
        <button
          className={`px-8 py-2 font-medium ${
            activeTab === "Scholarship"
              ? "bg-primary text-white rounded-xl"
              : "border border-primary rounded-xl text-primary hover:text-white hover:bg-primary duration-300"
          }`}
          onClick={() => handleTabChange("Scholarship")}
        >
          SCHOLARSHIP
        </button>
        {/* Add more tabs here */}
      </div>
      <hr />

      {/* Content */}
      <div className="px-8 py-16">
        {activeTab === "overview" && (
          <div className="flex flex-wrap">
            <div className="md:w-1/2 md:p-10 mb-6">
              <h2 className="text-4xl md:text-5xl text-primary font-bold mb-6">
                Here Are Some Facts You Should Know
              </h2>
              <p className="text-base opacity-60 mb-10">
                
              </p>
              <div>
              <a
                href="/application"
                className="uppercase text-white bg-secondary py-3 px-8 rounded-full hover:bg-gray-cool duration-300"
                >
                start application
              </a>
                </div>
            </div>
            <div className="">
              <div className="border border-gray-neutral bg-white flex gap-2 p-2 mb-5 w-[260px] rounded-xl">
                <img src={Student} alt="student" />
                <div>
                  <p className="opacity-60">International Students</p>
                  <h3 className="text-primary text-lg">
                    {country.overview.students}
                  </h3>
                </div>
              </div>
              <div className="border border-gray-neutral bg-white flex gap-2 p-2 mb-5 w-[260px] rounded-xl">
                <img src={Flag} alt="student" />
                <div>
                  <p className="opacity-60">Capital</p>
                  <h3 className="text-primary text-lg">
                    {country.overview.capital}
                  </h3>
                </div>
              </div>
              <div className="border border-gray-neutral bg-white flex gap-2 p-2 mb-5 w-[260px] rounded-xl">
                <img src={Money} alt="student" />
                <div>
                  <p className="opacity-60">Currency</p>
                  <h3 className="text-primary text-lg">
                    {country.overview.currency}
                  </h3>
                </div>
              </div>
              <div className="border border-gray-neutral bg-white flex gap-2 p-2 mb-5 w-[260px] rounded-xl">
                <img src={Gdp} alt="student" />
                <div>
                  <p className="opacity-60">GDP</p>
                  <h3 className="text-primary text-lg">
                    {country.overview.gdp}
                  </h3>
                </div>
              </div>
            </div>
            <div className="md:ms-5">
              <div className="border border-gray-neutral bg-white flex gap-2 p-2 mb-5 w-[260px] rounded-xl">
                <img src={Uni} alt="student" />
                <div>
                  <p className="opacity-60">Universities and Colleges</p>
                  <h3 className="text-primary text-lg">
                    {country.overview.colleges}
                  </h3>
                </div>
              </div>
              <div className="border border-gray-neutral bg-white flex gap-2 p-2 mb-5 w-[260px] rounded-xl">
                <img src={Language} alt="student" />
                <div>
                  <p className="opacity-60">Languages</p>
                  <h3 className="text-primary text-lg">
                    {country.overview.language}
                  </h3>
                </div>
              </div>

              <div className="border border-gray-neutral bg-white flex gap-2 p-2 mb-5 w-[260px] rounded-xl">
                <img src={Phone} alt="student" />
                <div>
                  <p className="opacity-60">Dailing Code</p>
                  <h3 className="text-primary text-lg">
                    {country.overview.dailingCode}
                  </h3>
                </div>
              </div>
              <div className="border border-gray-neutral bg-white flex gap-2 p-2 mb-5 w-[260px] rounded-xl">
                <img src={Population} alt="student" />
                <div>
                  <p className="opacity-60">Population</p>
                  <h3 className="text-primary text-lg">
                    {country.overview.population}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "schools" && (
          <div className="">
            <div className="text-center ">
              <h2 className="capitalize text-4xl text-primary font-bold mb-6">
                popular schools in {country.name}
              </h2>
              <div className="mt-20">
                <ul className="flex flex-wrap gap-4 mb-16 justify-center">
                  {country.schools.map((school) => (
                    <a
                    href="/"
                      key={school.id}
                      className="mb-2 border text-start border-gray-neutral bg-white flex gap-4 p-3 max-w-[290px] items-center rounded-xl"
                    >
                      <img src={school.logo} alt="logo" width={80}/>
                      <div>
                        <h3 className="text-base">
                          {school.name}
                        </h3>
                      </div>
                    </a>
                  ))}
                </ul>
              </div>
              <a
                href="/application"
                className="uppercase text-white bg-secondary w-40 py-3 px-8 rounded-full hover:bg-gray-cool duration-300"
              >
                start application
              </a>
            </div>
          </div>
        )}
        {activeTab === "programs" && (
          <div className="">
            <div className="text-center ">
              <h2 className="capitalize text-4xl text-primary font-bold mb-6">
                Top Study Programs
              </h2>
              <p className="text-base opacity-60 mx-auto md:w-1/2 mb-10">
                {country.name} offers some of the world’s most highly regarded programs
                across multiple disciplines
              </p>
              <div className="flex flex-wrap gap-10 justify-center pt-6 mb-10">
                <div className="flex gap-2">
                  <img src={Check} alt="check" width={24} height={24} />
                  <p> Undergraduate Degrees</p>
                </div>
                <div className="flex gap-2">
                  <img src={Check} alt="check" width={24} height={24} />
                  <p> Postgraduate Degrees</p>
                </div>
                <div className="flex gap-2">
                  <img src={Check} alt="check" width={24} height={24} />
                  <p> Diplomas/Certificates</p>
                </div>
              </div>
              <div>
                <ul className="flex flex-wrap gap-10 mb-16 justify-center">
                  {country.programs.map((program) => (
                    <li
                      key={program.id}
                      className="mb-4 border text-start border-gray-neutral bg-white flex gap-4 p-4 w-[450px] items-start rounded-xl"
                    >
                      <img src={School} alt="programs" />
                      <div>
                        <h3 className="text-xl text-primary font-bold">
                          {program.name}
                        </h3>
                        <p className="text-sm opacity-60 w-full mt-1">
                          {program.description}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <a
                href="/application"
                className="uppercase text-white bg-secondary w-40 py-3 px-8 rounded-full hover:bg-gray-cool duration-300"
              >
                start application
              </a>
            </div>
          </div>
        )}
        {activeTab === "admissions" && (
          <div className="">
            <div className="text-center ">
              <h2 className="capitalize text-4xl text-primary font-bold mb-6">
                Admission Requirements {country.name}
              </h2>

              <div className="mt-20">
                <ul className="flex flex-wrap gap-6 mb-16 justify-center">
                  {country.admissions.map((admission) => (
                    <li
                      key={admission.id}
                      className="mb-4 border text-start border-gray-neutral bg-white flex gap-4 p-4 w-[450px] items-start rounded-xl"
                    >
                      <img src={Check} alt="programs" />
                      <div>
                        <h3 className="text-xl text-primary font-bold">
                          {admission.name}
                        </h3>
                        <p className="text-sm opacity-60 w-full mt-1">
                          {admission.description}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <a
                href="/application"
                className="uppercase text-white bg-secondary w-40 py-3 px-8 rounded-full hover:bg-gray-cool duration-300"
              >
                start application
              </a>
            </div>
          </div>
        )}
        {activeTab === "tuition" && (
          <div className="">
            <div className="text-center ">
              <div className="px-4 py-8 bg-white w-full h-full border border-gray-neutral rounded-2xl">
                <h2 className="capitalize text-3xl text-primary font-bold mb-2">
                  Tuition
                </h2>
                <p>Average Tuition In {country.name}</p>

                <div className="flex flex-wrap justify-center md:gap-16 mt-12">
                  <div className="flex text-start gap-3 p-2 mb-5">
                    <img src={School} alt="student" width={50} className="p-1 bg-alice-blue rounded-md"/>
                    <div>
                      <p className="text-xl">Undergraduate</p>
                      <p className="opacity-50  text-sm">
                        {country.fees.undergraduate}
                      </p>
                    </div>
                  </div>
                  <div className="flex text-start gap-3 p-2 mb-5">
                    <img src={School} alt="student" width={50} className="p-1 bg-alice-blue rounded-md"/>
                    <div>
                      <p className="text-xl">Postgraduate</p>
                      <p className="opacity-50  text-sm">
                        {country.fees.postgraduate}
                      </p>
                    </div>
                  </div>
                  <div className="flex text-start gap-3 p-2 mb-5">
                    <img src={School} alt="student" width={50} className="p-1 bg-alice-blue rounded-md"/>
                    <div>
                      <p className="text-xl">PHD</p>
                      <p className="opacity-50  text-sm">
                        {country.fees.phd}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="px-4 py-8 my-10 bg-white w-full h-full border border-gray-neutral rounded-2xl">
                {
                  country.name === "Canada" ?
                  <h2 className="capitalize text-3xl text-primary font-bold mb-2">
                IRCC Estimated cost of living
                </h2> :
                <h2 className="capitalize text-3xl text-primary font-bold mb-2">
                Cost Of Living
                </h2>
                }
                {/* <h2 className="capitalize text-3xl text-primary font-bold mb-2">
                Cost Of Living
                </h2> */}
                <p>Average Monthly Expenses In {country.name}</p>

                <div className="flex flex-wrap justify-center md:gap-16 mt-12">
                  <div className="flex text-start gap-3 p-2 mb-5">
                    <img src={Rent} alt="student" width={50} className="p-1 bg-alice-blue rounded-md"/>
                    <div>
                      <p className="text-xl">Rent</p>
                      <p className="opacity-50  text-sm">
                        {country.fees.rent}
                      </p>
                    </div>
                  </div>
                  <div className="flex text-start gap-3 p-2 mb-5">
                    <img src={Transport} alt="student" width={50} className="p-1 bg-alice-blue rounded-md"/>
                    <div>
                      <p className="text-xl">Transport</p>
                      <p className="opacity-50  text-sm">
                        {country.fees.transport}
                      </p>
                    </div>
                  </div>
                  <div className="flex text-start gap-3 p-2 mb-5">
                    <img src={Food} alt="student" width={50} className="p-1 bg-alice-blue rounded-md"/>
                    <div>
                      <p className="text-xl">Food</p>
                      <p className="opacity-50  text-sm">
                        {country.fees.food}
                      </p>
                    </div>
                  </div>
                  <div className="flex text-start gap-3 p-2 mb-5">
                    <img src={Health} alt="student" width={50} className="p-1 bg-alice-blue rounded-md"/>
                    <div>
                      <p className="text-xl">Health Insurance</p>
                      <p className="opacity-50  text-sm">
                        {country.fees.internet}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <a
                href="/application"
                className="uppercase text-white bg-secondary w-40 py-3 px-8 rounded-full hover:bg-gray-cool duration-300"
              >
                start application
              </a>
            </div>
          </div>
        )}
        {activeTab === "Scholarship" && (
          <div className="">
            <div className="text-center ">
              <div className="px-4 py-8 mb-10 bg-white w-full h-full border border-gray-neutral rounded-2xl">
                <h2 className="capitalize text-3xl text-primary font-bold mb-2">
                  Scholarship & Discount
                </h2>
                <p className="mt-16">Scholarships & tuition discount available from</p>
                <p className="text-5xl text-primary font-bold mt-2">10 - 50%</p>

                <div className="flex flex-wrap justify-center md:gap-16 mt-12">
                
                
                </div>
              </div>
              
              <a
                href="/application"
                className="uppercase text-white bg-primary w-40 py-3 px-8 rounded-full hover:bg-gray-cool duration-300"
              >
                start application
              </a>
            </div>
          </div>
        )}
       
      </div>
    </div>
  );
};

export default CountryTabs;
